import React from 'react'
import styled from 'styled-components'
import { Tooltip } from 'antd'

import githubIcon from '../Assets/Images/githubIcon.svg'
import instagramIcon from '../Assets/Images/instagramIcon.svg'
import mediumIcon from '../Assets/Images/mediumIcon.svg'

const Sidebar = () => {
  return (
    <Wrapper>
      <Tooltip title="Visit GitHub" placement="left">
        <a
          href="https://github.com/KxllSwxtch"
          target="__blank"
          className="icon-wrapper"
        >
          <Icon src={githubIcon} />
        </a>
      </Tooltip>

      <Tooltip title="Visit Instagram" placement="left">
        <a
          href="https://www.instagram.com/dmitrsky"
          target="__blank"
          className="icon-wrapper"
        >
          <Icon src={instagramIcon} />
        </a>
      </Tooltip>

      <Tooltip title="Visit Medium" placement="left">
        <a
          href="https://medium.com/@dimashin9"
          target="__blank"
          className="icon-wrapper"
        >
          <Icon src={mediumIcon} />
        </a>
      </Tooltip>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 900px) {
    display: none;
    flex-direction: row;
  }
`

const Icon = styled.img`
  margin: 0 auto 30px auto;
  transition: all 300ms cubic-bezier(0.165, 0.84, 0.44, 1);
  border-radius: 5px;
  padding: 10px;
  display: block;

  &:hover {
    transform: translateX(3px);
    background-color: #ff206e;
  }
`

export default Sidebar
